export default __webpack_public_path__ + "static/media/ferramenta-reels-img8.a2902a4c.jpeg";